import { makeAutoObservable } from "mobx";

import { AppRole, UserPermissionsDto } from "../../@api";

export class PermissionStore {
  private _userPermissions: UserPermissionsDto = { isPermissionAdmin: false, roles: [] };

  constructor() {
    makeAutoObservable(this);
  }

  public get userPermissions() {
    return this._userPermissions;
  }

  public setUserPermissions(userPermissions?: UserPermissionsDto) {
    if (!userPermissions) {
      this._userPermissions = {
        isPermissionAdmin: false,
        roles: [],
      };
    } else {
      this._userPermissions = userPermissions;
    }
  }

  public hasRole(role: AppRole): boolean {
    return this._userPermissions.roles.includes(role);
  }

  public isPermissionAdmin(): boolean {
    return this._userPermissions.isPermissionAdmin;
  }

  public hasAnyAdminRole(): boolean {
    if (this.isPermissionAdmin()) {
      return true;
    }

    const adminRoles = Object.values(AppRole).filter(role => role.endsWith("Admin"));
    return this.hasAnyRole(adminRoles);
  }

  public hasAnyRole(roles: AppRole[]): boolean {
    return roles.some(role => this._userPermissions.roles.includes(role));
  }
}
